import {Equipment} from '@models/equipment';
import {Calibration} from '@models/card/calibration';
import {EquipmentEnums, EquipmentInterfaces} from '@namespaces/equipment.namespace';

/**
 * Просмотр модели оборудования
 */
export class EquipmentPreview extends Equipment {
    /**
     * Label межповерочного интервала, в зависимости от типа поверки или калибровки
     */
    public verificationLabel: string;

    /**
     * Значение межповерочного интервала
     */
    public verificationValue: string;

    /**
     * Информация о производителе
     */
    public manufacturerInfo: string;

    constructor(
        _rawData: EquipmentInterfaces.Model
    ) {
        super(_rawData);
    }

    setAttributes() {
        super.setAttributes();

        this.verificationLabel = Calibration.getCalibrationLabel(
            this.rawData.verification_status,
            'Межповерочный интервал',
            'Интервал между калибровками'
        ) + ' в месяцах';

        this.verificationValue = this.rawData.verification_status !== EquipmentEnums.VerificationStatus.inapplicable ?
            this.rawData.verification_interval.toString() : 'Не требуется';

        this.manufacturerInfo = this.getManufacturerInfo();
    }

    private getManufacturerInfo(): string {
        const info = [];
        const {country, manufacturer} = this.rawData;
        if (manufacturer) {
            info.push(manufacturer);
        }

        if (country) {
            info.push(country);
        }

        return info.join(', ');
    }
}
